import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./loader.style.css";

function Loader({ message }) {
  const { t } = useTranslation();
  const displayMessage = message || t('common.loading');

  return (
    <div className="custom-loader-overlay" role="progressbar" aria-busy="true" aria-live="polite">
      <div className="custom-loader-content enhanced-loader">
        <div className="hammer-nail-loader" aria-hidden="true">
          <svg width="100" height="100" viewBox="0 0 100 100" focusable="false">
            {/* Nail (flipped 180deg) */}
            <g transform="rotate(180 50 74)">
              <rect x="47" y="60" width="6" height="28" rx="2" fill="#b0b0b0" />
              <rect x="44" y="86" width="12" height="6" rx="2" fill="#888" />
            </g>
            {/* Hammer group for easier transform */}
            <g className="hammer-group" transform="rotate(90 40 41) translate(0,9)">
              {/* Hammer handle */}
              <rect
                className="hammer-handle"
                x="36"
                y="18"
                width="8"
                height="38"
                rx="3"
                fill="#b97a56"
              />
              {/* Hammer head */}
              <rect
                className="hammer-head"
                x="30"
                y="16"
                width="20"
                height="10"
                rx="3"
                fill="#444"
              />
              <rect
                className="hammer-head"
                x="46"
                y="12"
                width="8"
                height="18"
                rx="3"
                fill="#888"
              />
            </g>
          </svg>
        </div>
        <p className="custom-loader-message enhanced-message" role="status">
          {displayMessage}
        </p>
      </div>
    </div>
  );
}

Loader.propTypes = {
  message: PropTypes.string,
};


export default Loader;
